import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';
import {ModemService} from '../services/modem.service';
import {NgxSpinnerService} from 'ngx-spinner';
import { FirmService } from '../services/firm.service';
import { Firms } from '../models/firms';

@Component({
    selector: 'app-firm-modem',
    templateUrl: './firm-modem.component.html',
    styleUrls: ['./firm-modem.component.css']
})
export class FirmModemComponent implements OnInit {
    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    private firmId: string;
    public modems = [];
    public modemsFirstDeactive = [];
    public modemsSecondsActive = [];
    public selectedId;
    public firm: any;
    public searchText;
    public selectedModem = {firm: new Firms(), mark: '', sn: '-1', imei: '', bandwidth: '', status: '-1'};
    flag: string = '';
    loading = false;
    firms = [];
    firmDetail = [];
    constructor(private modemService: ModemService,
                private router: Router,
                private route: ActivatedRoute,
                private firmService: FirmService,
                private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.spinner.show();
        this.firm = localStorage.getItem('firm');
        this.firmId = localStorage.getItem('firmId');
        this.flag = this.route.snapshot.paramMap.get('flag');
        if(this.flag === 'varliklar') {
            this.getModemsForSuperAdmin();
        } else {
            this.getModemsByFirm(this.firmId);
        }
        this.getAllFirms();
    }

    getModemsByFirm(firmId: string) {
            this.modemService.getModemsByFirm(firmId).subscribe(res => {
                this.modems = res.dataModems;
                this.modems = [];
                this.modemsFirstDeactive = [];
                this.modemsSecondsActive = [];
                res.dataModems.forEach(data => {
                    if (!data.status) {
                        this.modemsFirstDeactive.push(data);
                    } else {
                        this.modemsSecondsActive.push(data);
                    }
                });
                this.modems = this.modemsFirstDeactive.concat(this.modemsSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
    }
    getModemsForSuperAdmin() {
        this.spinner.show();
        this.flag = this.route.snapshot.paramMap.get('flag');
        if (this.flag === 'varliklar') {
            this.modemService.getModemsForSuperAdmin().subscribe(res => {
                this.modems = res.dataModems;
                this.modems = [];
                this.modemsFirstDeactive = [];
                this.modemsSecondsActive = [];
                res.forEach(data => {
                    if (!data.status) {
                        this.modemsFirstDeactive.push(data);
                    } else {
                        this.modemsSecondsActive.push(data);
                    }
                });
                this.modems = this.modemsFirstDeactive.concat(this.modemsSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
        }
    }
    createModem(mark, sn, imei, bandwidth, status) {
        if (mark === '' || mark === undefined || sn === '' || sn === undefined ||
            imei === '' || imei === undefined || bandwidth === '' || bandwidth === undefined || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const Modem = {
            mark: mark, sn: sn, imei: imei, bandwidth: bandwidth,
            firm: this.firmId, status: status
        };
        this.modemService.createModem(Modem).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeCreateModal.nativeElement.click();
            if(this.flag === 'varliklar') {
                this.getModemsForSuperAdmin();
            } else {
                this.getModemsByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    updateModem(mark, sn, imei, bandwidth, status) {
        if (mark === '' || mark === undefined || sn === '' || sn === undefined ||
            imei === '' || imei === undefined || bandwidth === '' || bandwidth === undefined || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.hide();
        const Modem = {
            mark: mark, sn: sn, imei: imei, bandwidth: bandwidth,
            firm: this.firmId, status: status
        };
        this.modemService.updateModem(Modem, this.selectedId).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();
            if(this.flag === 'varliklar') {
                this.getModemsForSuperAdmin();
            } else {
                this.getModemsByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getModemById(id) {
        this.spinner.show();
        this.modemService.getModemById(id).subscribe(res => {
            this.selectedModem = res;
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    selected(id) {
        this.selectedId = id;
        this.getModemById(id);
    }

    deleteModem(id) {
        if (id === '' || id === undefined) {
            this.errorSwal.title = 'Modem id alınamadı!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        this.modemService.deleteModem(id).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            if(this.flag === 'varliklar') {
                this.getModemsForSuperAdmin();
            } else {
                this.getModemsByFirm(id);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getAllFirms() {
        this.firmService.getAllFirms().subscribe(res => {
            if (res.success) {
                this.firms = res.firms;
                for (const firm of this.firms) {
                    this.firmDetail.push(firm._id);
                }
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }

    onSelectModemCreate() {
        this.firmId = this.selectedModem.firm._id;
    }
    onSelectModemUpdate() {
        this.firmId = this.selectedModem.firm._id;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-modem/firm-modem.component.ts